import { render, staticRenderFns } from "./SalaryDetailsItem.vue?vue&type=template&id=6a51e1b7&scoped=true"
import script from "./SalaryDetailsItem.vue?vue&type=script&lang=js"
export * from "./SalaryDetailsItem.vue?vue&type=script&lang=js"
import style0 from "./SalaryDetailsItem.vue?vue&type=style&index=0&id=6a51e1b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a51e1b7",
  null
  
)

export default component.exports